import React from 'react';
import {
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Input,
	CustomInput,
	FormGroup,
	Row,
	Col,
	UncontrolledTooltip,
	Button
} from 'reactstrap';
import { Auth } from "aws-amplify";
import img1 from '../../assets/images/logo2@2x.png';
import img2 from '../../assets/images/background/login-register.jpg';
import azenaevosupportlogo from '../../assets/images/support_logo.png';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { authenticationService } from '../../jwt/_services';
const sidebarBackground = {
	//backgroundImage: "url(" + img2 + ")",
	backgroundColor: "#313642",
	backgroundRepeat: "no-repeat",
	backgroundPosition: "bottom center"
};

const formBackground = {
	//backgroundImage: "url(" + img2 + ")",
	backgroundColor: "#414755"
};

class Register extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			email: '',
			password: '',
			code: '',
			responseData: [],
			waitingForCode: false,
	  };

		this.handleClick = this.handleClick.bind(this);
	}
	handleClick() {
		console.log('submitted');
	}

	confirmSignUp = (e) => {
		Auth.confirmSignUp(this.state.email, this.state.code)
      .then((data) => {
				console.log('confirmSignUp');
        console.log(data);
				this.setState({waitingForCode: false});
				this.setState({email: ''});
				this.setState({code: ''});
      })
      .catch((err) => console.log('confirmSignUp error: '+err));
	}

	resendCode = () => {
		Auth.resendSignUp(this.state.email)
      .then(() => {
        console.log("code resent successfully");
      })
      .catch((e) => {
        console.log('resendCode error: '+e);
      });
	}

	render() {
		return <div className="">
			{/*--------------------------------------------------------------------------------*/}
			{/*Register Cards*/}
			{/*--------------------------------------------------------------------------------*/}
			<div className="auth-wrapper d-flex no-block justify-content-center align-items-center" style={sidebarBackground}>
				<div className="auth-box on-sidebar" style={formBackground}>
					<div id="registerform">
						<div className="logo">
							<span className="db"><img style={{ width: "100%"}} src={azenaevosupportlogo} alt="logo" /></span>
							<h5 className="mb-3"></h5>
							<h5 className="font-medium mb-3 text-light">Sign Up to Admin</h5>
						</div>
						<Row>
							<Col xs="12">
								{!this.state.waitingForCode ? (
									<Formik
															initialValues={{
																	email: '',
																	password: '',
																	passwordConfirm: '',
																	firstname: '',
																	lastname: '',
																	market: ''
															}}
															validationSchema={Yup.object().shape({
																	email: Yup.string().required('Email is required'),
																	password: Yup.string().required('Password is required'),
																	passwordConfirm: Yup.string().required('Password Confirmation is required'),
																	firstname: Yup.string().required('First Name is required'),
																	lastname: Yup.string().required('Last Name is required'),
																	market: Yup.string().required('Market is required')
															})}
															onSubmit={({ firstname, lastname, email, password, passwordConfirm, market }, { setStatus, setSubmitting }) => {
																	setStatus();
																	console.log('submitted');

																	if (password==passwordConfirm) {
																		if (market!='select') {
																			Auth.signUp({ username: email, password, attributes: {
																				'email': email,
																				'given_name': firstname,
																				'family_name': lastname,
																				'custom:market': market
																				}
																			})
																      .then((data) => {
																        console.log('confirmSignUp data: '+JSON.stringify(data));
																				firstname = '';
																				this.setState({waitingForCode: true});
																        this.setState({password: password});
																				this.setState({email: email});
																				this.setState({responseData: data});
																				setSubmitting(false);
																				document.getElementById("signUpCode").value = "";
																      })
																      .catch((err) => {
																        console.log('signUp error: '+JSON.stringify(err));
																				setStatus(err.message);
																				setSubmitting(false);
																      });
																		} else {
																			console.log('Market Not Selected.');
																			setStatus("Please select your market.");
																			setSubmitting(false);
																		}
																	} else {
																		console.log("Passwords don't match.");
																		setStatus("Password and Confirmation Password must match.");
																		setSubmitting(false);
																	}



															}}
															render={({ errors, status, touched, isSubmitting }) => (
									<Form className="mt-3" id="registerform">
										<InputGroup className="mb-3">
											<InputGroupAddon addonType="prepend">
											</InputGroupAddon>
											<Field id="firstname" name="firstname" placeholder="First Name" type="text" className={'form-control' + (errors.firstname && touched.firstname ? ' is-invalid' : '')} />
	                                		<ErrorMessage name="firstname" component="div" className="invalid-feedback" />
										</InputGroup>
										<InputGroup className="mb-3">
											<InputGroupAddon addonType="prepend">
											</InputGroupAddon>
											<Field id="lastname" name="lastname" placeholder="Last Name" type="text" className={'form-control' + (errors.lastname && touched.lastname ? ' is-invalid' : '')} />
	                                		<ErrorMessage name="lastname" component="div" className="invalid-feedback" />

										</InputGroup>
										<InputGroup className="mb-3">
											<InputGroupAddon addonType="prepend">
											</InputGroupAddon>
											<Field component="select" id="market" name="market" className={'form-control' + (errors.market && touched.market ? ' is-invalid' : '')}>
												 <option value="select">Select</option>
											   <option value="us">United States</option>
											   <option value="europe">Europe</option>
												 <option value="aus">Australia</option>
												 <option value="brazil">Brazil</option>
												 <option value="taiwan">Taiwan</option>
												 <option value="colombia">Colombia</option>
												 <option value="mexico">Mexico</option>
												 <option value="czech">Czech</option>
											</Field>
																 <ErrorMessage name="market" component="div" className="invalid-feedback" />
										</InputGroup>
										<InputGroup className="mb-3">
											<InputGroupAddon addonType="prepend">
											</InputGroupAddon>

											<Field id="email" name="email" type="text" placeholder="Email" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')}  autocomplete="new-email"/>
	                                		<ErrorMessage name="email" component="div" className="invalid-feedback" />
										</InputGroup>
										<InputGroup className="mb-3">
											<InputGroupAddon addonType="prepend">
											</InputGroupAddon>
											<Field id="password" name="password" type="password" placeholder="Password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')}  autocomplete="new-password"/>
	                                		<ErrorMessage name="password" component="div" className="invalid-feedback" />

										</InputGroup>
										<InputGroup className="mb-3">
											<InputGroupAddon addonType="prepend">
											</InputGroupAddon>
											<Field id="passwordConfirm" name="passwordConfirm" type="password" placeholder="Confirm Password" className={'form-control' + (errors.passwordConfirm && touched.passwordConfirm ? ' is-invalid' : '')}  autocomplete="new-password"/>
	                                		<ErrorMessage name="passwordConfirm" component="div" className="invalid-feedback" />

										</InputGroup>
										<CustomInput className=" text-light" type="checkbox" id="exampleCustomCheckbox" label="I agree to all Terms" />
										<Row className="mb-3 mt-3">
											<Col xs="12">
												<button type="submit" className="btn btn-block btn-primary" disabled={isSubmitting}>Sign Up</button>
											</Col>
										</Row>
										{status &&
	                                <div className={'alert alert-danger'}>{status}</div>
	                            }
										<div className="text-center text-light">
											Already have an account? <a href="/authentication/login" className="text-info ml-1"><b>Sign In</b></a>
										</div>
									</Form>
									)}
									/>
								) : (
									<Formik
															initialValues={{
																	signUpCode: ''
															}}
															validationSchema={Yup.object().shape({
																	signUpCode: Yup.string().required('Sign Up Code is required')
															})}
															onSubmit={({ signUpCode }, { setStatus, setSubmitting }) => {
																	setStatus();
																	console.log('submitted');

																	Auth.confirmSignUp(this.state.email, signUpCode)
															      .then((data) => {
																			console.log('confirmSignUp');
															        console.log(data);
																			setStatus(data);
																			this.setState({waitingForCode: false});
																			setSubmitting(false);
																			window.location.href="/authentication/login";
															      })
															      .catch((err) => {
																			console.log('confirmSignUp error: '+err);
																			setSubmitting(false);
																		});

															}}
															render={({ errors, status, touched, isSubmitting }) => (
									<Form className="mt-3" id="confirmForm">
										<InputGroup className="mb-3">
											<InputGroupAddon addonType="prepend">
											</InputGroupAddon>
											<Field id="signUpCode" name="signUpCode" placeholder="Sign Up Code" type="text" className={'form-control' + (errors.signUpCode && touched.signUpCode ? ' is-invalid' : '')} />
																			<ErrorMessage name="signUpCode" component="div" className="invalid-feedback" />
										</InputGroup>
										<Row className="mb-3 mt-3">
											<Col xs="6">
												<button type="submit" className="btn btn-block btn-primary" disabled={isSubmitting}>Confirm Sign Up</button>
											</Col>
											<Col xs="6">
												<button className="btn btn-block btn-primary" disabled={isSubmitting} onClick={() => this.resendCode()}>Resend code</button>
											</Col>
										</Row>
										{status &&
	                  	<div className={'alert alert-danger'}>{status}</div>
	                  }
									</Form>
									)}
									/>
								)}
							</Col>
						</Row>
					</div>
				</div>
			</div>
		</div>;
	}
}

export default Register;
